/*

FILE: animations.js
DESCRIPTION: Element entrances and animations
AUTHOR(S): R.J. LaCount

*/


import anime from 'animejs/lib/anime.es.js';

const initHeadlineEntrance = (hero) => {
	const container = hero.querySelector('.entrance-container');
	const headlineContainer = hero.querySelector('.entrance-headline');
	const headlineSegments = headlineContainer.querySelectorAll('span');
	const details = hero.querySelector('.entrance-details');

	const tl = anime.timeline({
		easing: 'easeInOutQuart'
	});
	tl
		.add({
			targets: [container, headlineContainer, headlineSegments, details],
			opacity: 0,
			duration: 600
		})
		.add({
			targets: container,
			opacity: 1,
			duration: 900
		})
		.add({
			targets: headlineContainer,
			opacity: 1,
			duration: 900
		}, '-=600')
		.add({
			targets: headlineSegments,
			opacity: 1,
			translateX: ['-1rem', '0'],
			duration: 900,
			delay: anime.stagger(200)
		}, '-=900')
		.add({
			targets: details,
			opacity: 1,
			duration: 900
		}, '-=900');
}

export { initHeadlineEntrance };
